import React, { lazy } from "react";

const LazyLanding = lazy(() => import("./Landing"));

const Landing = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyLanding {...props} />;

export default Landing;
